<template>
   <div id="card_sentenciado_step0" class="card mb-0" ref="sentenciado" :class="sentenciado.status == 'DESCUMPRIMENTO' || sentenciado.status == 'Descumprimento' ? 'border-danger' : ''">
      <div class="card-body">
         <div class="d-flex align-items-center">
            <div class="flex-grow-1" id="card_sentenciado_step1">
               <h5 class="mb-1 limitador font-18" :title="sentenciado.nomeCompleto">{{sentenciado.nomeCompleto}}</h5>
               <p class="text-muted mb-0 limitador" :title="sentenciado.nomeEntidade">{{sentenciado.nomeEntidade}}</p>
            </div>
            <div class="dropdown" id="card_sentenciado_step7">
               <button class="btn btn-theme" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-ellipsis-v"></i>
               </button>
               <ul class="dropdown-menu dropdown-menu-right">
                  <li class="cursor-pointer"><a class="dropdown-item" @click="editar"><i class="fas fa-edit mr-2"></i>Editar</a></li>
                  <li class="cursor-pointer"><a class="dropdown-item" @click="imprimir"><i class="fas fa-print mr-2"></i>Imprimir</a></li>
                  <li class="cursor-pointer"><a class="dropdown-item" @click="excluir"><i class="fas fa-trash mr-2"></i>Excluir</a></li>
               </ul>
            </div>
         </div>
         
         <hr class="my-3">
         
         <div class="row g-3" id="card_sentenciado_step2">
            <div class="col-md-6 mb-2">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block"><i class="fas fa-gavel mr-2"></i>Processo</small>
                     <span class="limitador">{{sentenciado.numeroProcesso || 'Não informado'}}</span>
                  </div>
               </div>
            </div>
            <div class="col-md-6">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block"><i class="fas fa-folder mr-2"></i>Pasta</small>
                     <span class="limitador">{{ sentenciado.numeroPasta || 'Não informado' }}</span>
                  </div>
               </div>
            </div>
            <div class="col-md-6 mb-2">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block"><i class="fas fa-id-card mr-2"></i>{{sentenciado.tipoDocumento || 'Documento'}}</small>
                     <span class="limitador">{{sentenciado.identificacao || 'Não informado'}}</span>
                  </div>
               </div>
            </div>
            <div class="col-md-6 mb-2" id="card_sentenciado_step3">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block">
                        <i class="fas mr-2" :class="sentenciado.status == 'DESCUMPRIMENTO' || sentenciado.status == 'Descumprimento' ? 'fa-exclamation-circle text-danger' : 'fa-info-circle'"></i>Status
                     </small>
                     <span class="limitador" :class="sentenciado.status == 'DESCUMPRIMENTO' || sentenciado.status == 'Descumprimento' ? 'text-danger' : ''">{{(sentenciado.status ? sentenciado.status.charAt(0).toUpperCase() + sentenciado.status.slice(1).toLowerCase() : 'Não informado')}}</span>
                  </div>
               </div>
            </div>
            <div class="col-md-6" v-if="modoVisao == 'visaoDetalhada'">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block"><i class="fas fa-venus-mars mr-2"></i>Sexo</small>
                     <span class="limitador">{{sentenciado.sexo || 'Não informado'}}</span>
                  </div>
               </div>
            </div>
            <div class="col-md-6 mb-2" v-if="modoVisao == 'visaoDetalhada'">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block"><i class="fas fa-calendar-check mr-2"></i>Encaminhado(a) em:</small>
                     <span class="limitador">{{ sentenciado.encaminhamento ? sentenciado.encaminhamento.split('-').reverse().join('/') : 'Não informado' }}</span>
                  </div>
               </div>
            </div>
            <div class="col-12 mb-2" v-if="modoVisao == 'visaoDetalhada'">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block"><i class="fas fa-redo mr-2"></i>Reencaminhado(a) em:</small>
                     <span class="limitador">{{ sentenciado.reencaminhamento ? sentenciado.reencaminhamento.split('-').reverse().join('/') + ' - ' + sentenciado.encaminhado : 'Não informado' }}</span>
                  </div>
               </div>
            </div>
         </div>

         <div class="progress mt-3" style="height: 15px" id="card_sentenciado_step4">
            <div class="progress-bar bg-success font-12" 
                  :style="{width: (sentenciado.horasCumpridas/sentenciado.totalHoras*100) + '%', transition: 'width 0.5s ease'}"
                  :title="formatarMinutosParaHoras(sentenciado.horasCumpridas) + ' cumpridas'">
               {{sentenciado.horasCumpridas/sentenciado.totalHoras*100 >= 25 ? formatarMinutosParaHoras(sentenciado.horasCumpridas) : formatarMinutosParaHoras(sentenciado.horasCumpridas)}} h
            </div>
            <div class="progress-bar bg-warning font-12" 
                  :style="{width: (sentenciado.horasPendentes/sentenciado.totalHoras*100) + '%', transition: 'width 0.5s ease'}"
                  :title="formatarMinutosParaHoras(sentenciado.horasPendentes) + ' pendentes'">
               {{sentenciado.horasCumpridas/sentenciado.totalHoras*100 >= 75 ? formatarMinutosParaHoras(sentenciado.horasPendentes) : formatarMinutosParaHoras(sentenciado.horasPendentes)}} h
            </div>
         </div>
         <div class="d-flex justify-content-between mt-2">
            <small id="card_sentenciado_step5" class="text-muted">Total: {{formatarMinutosParaHoras(sentenciado.totalHoras)}} h</small>
            <small id="card_sentenciado_step6" :class="Math.round(sentenciado.horasCumpridas/sentenciado.totalHoras*100) === 100 ? 'text-success' : 'text-muted'">{{Math.round(sentenciado.horasCumpridas/sentenciado.totalHoras*100)}}% concluído</small>
         </div>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'Sentenciado',
   props: ['sentenciado', 'modoVisao', 'index'],
   computed: {
      ... mapState({
         tokenSessao: state => state.tokenSessao,
         urlRest: state => state.urlRest
      })
   },
   methods: {
      formatarMinutosParaHoras(minutos) {
         const horas = Math.floor(minutos / 60);
         const minutosRestantes = minutos % 60;
         return `${String(horas).padStart(2, '0')}:${String(minutosRestantes).padStart(2, '0')}`;
      },
      editar() {
         this.$emit('editar', this.sentenciado)
      },
      imprimir() {
         this.$emit('imprimir', this.sentenciado.id)
      },
      excluir() {
         this.$emit('excluir', this.sentenciado)
      },
   }
}

</script>
<style scoped>

.bg-success {
   background-color: var(--primary-color) !important;
}

.bg-warning {
   background-color: #7979794f !important;
}

.border-danger {
   border: 1px #D23443 solid !important;
}

</style>